import * as React from "react";
import PropTypes from 'prop-types';

const SvgExternalLink = props => {
  if (props.id !== "_svgexternallink") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 20 20" {...props}><path fillRule="evenodd" d="M8.092 4.375a.625.625 0 110 1.25H3.75V16.25h10.625v-4.342a.625.625 0 011.25 0v4.967c0 .346-.28.625-.625.625H3.125a.625.625 0 01-.625-.625V5c0-.346.28-.625.625-.625h4.967zM16.875 2.5c.345 0 .625.28.625.625v6.25a.625.625 0 11-1.25 0V4.571l-6.96 6.96a.625.625 0 01-.884-.884l6.897-6.897h-4.678a.625.625 0 010-1.25h6.25z" /></svg>;
};

SvgExternalLink.displayName = "_svgexternallink";
SvgExternalLink.propTypes = {
  id: PropTypes.string
};
SvgExternalLink.defaultProps = {
  id: ''
};
export default SvgExternalLink;